var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const TabsNavItemCore = (props) => {
    const { children, components, className, current, text, type, icon, id, onlyChild } = props, rest = __rest(props, ["children", "components", "className", "current", "text", "type", "icon", "id", "onlyChild"]);
    const { Anchor, Icon } = components;
    function BEM() {
        const classArray = ['tabs__nav-item'];
        if (current) {
            classArray.push('is-current');
        }
        if (onlyChild) {
            classArray.push('tabs__nav-item--only-child');
        }
        if (type) {
            classArray.push('tabs__nav-item--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (React.createElement("li", { className: BEM(), id: props.id, role: "presentation" },
        React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "tabs__nav-link", role: "tab" }),
            icon && (React.createElement(Icon, { modifiers: icon, align: "middle", className: "tabs__nav-item-icon" })),
            React.createElement("div", { className: "tabs__nav-link-inner" }, children || text))));
};
export { TabsNavItemCore as default, };
